import request from '@/utils/request'

// 获取验证码
export function getCaptchaApi() {
  return request({
    method: 'GET',
    url: 'v1/web/user/login/captcha',
    responseType: 'blob'
  })
}

// 用户登录
export function getLoginApi(data) {
  return request({
    method: 'POST',
    url: 'v1/web/user/login',
    data
  })
}

// 获取用户余额
export function getUserBalance() {
  return request({
    method: 'GET',
    url: 'v1/web/user/balance'
  })
}

// 获取用户余额列表
export function getBalanceListApi() {
  return request({
    method: 'GET',
    url: 'v1/web/user/balance/list'
  })
}

// 05获取用户信息
export function getInfo() {
  return request({
    method: 'get',
    url: 'v1/web/user/info'
  })
}

// 注册验证码
export function registerCodeApi(data) {
  return request({
    url: 'v1/web/user/register/code',
    method: 'post',
    data
  })
}

// 注册

export function registerApi(data) {
  return request({
    url: 'v1/web/user/register',
    method: 'post',
    data
  })
}
